var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manual"},[_c('van-nav-bar',{attrs:{"title":"关于我们","left-text":"返回","left-arrow":""},on:{"click-left":function($event){return _vm.$router.go('-1')}}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',[_vm._v("我们")]),_c('div',[_vm._v(" 杭州巨浪物联网科技有限公司 ")]),_c('p',[_vm._v("联系电话")]),_c('div',[_vm._v(" 17888888888 ")])])
}]

export { render, staticRenderFns }